// extracted by mini-css-extract-plugin
export default {"customCard":"customCard_customCard__USo-r","cardImageContainer":"customCard_cardImageContainer__7JzKm","cardImage":"customCard_cardImage__lsTsk"};